// extracted by mini-css-extract-plugin
module.exports = {"root":"SaltLegend_root__18P_g"};